import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loading from "components/atoms/Loading";
import { UserContext } from "components/context/UserContext";
import { useRouter } from "components/hooks";
import { ROUTES, TOAST_CONFIG } from "../../constants";
import { get } from "../../utils/request";
import UserProfile from "../UserProfile/UserProfile";
import { getUserPublicProfile } from "../../apis/user";

function UserPublicProfilePage() {
  const [userPublicDetails, setUserPublicDetails] = useState<User>();
  const [userDataLoading, setUserDataLoading] = useState(true);
  const router = useRouter();
  const { userId } = router.query;

  const { isUserLoggedIn } = useContext(UserContext);

  if (isUserLoggedIn) {
    const { userDetails } = useContext(UserContext);
    if (userDetails?.username === userId) router.go(ROUTES.USER_PROFILE_PAGE, { replace: true });
  }

  const handleGetUserPublicDetailsSuccess = ({ data }: { data: User }) => {
    setUserPublicDetails(data);
    setUserDataLoading(false);
  };

  const handleGetUserPublicDetailsError = () => {
    toast.error("Failed to fetch user public profile", TOAST_CONFIG);
    setUserDataLoading(false);
  };

  const getUserPublicDetails = () => {
    get(getUserPublicProfile(userId), {
      processData: handleGetUserPublicDetailsSuccess,
      processError: handleGetUserPublicDetailsError,
    });
  };

  useEffect(() => {
    getUserPublicDetails();
  }, []);

  if (userDataLoading || !userPublicDetails) {
    return <Loading />;
  }
  return <UserProfile userDetails={userPublicDetails} />;
}
export default UserPublicProfilePage;
